import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import "@vibe/core/tokens";
import { MondayProvider } from "./hooks/useMondayContext";
import PropertyDailyTodoList from "./PropertyDailyTodoList";
import mondayApi from "./services/mondayApiStandalone";

const App = () => {
  const [boardId, setBoardId] = useState(null);
  const [apiLoading, setApiLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    // Initialize API with environment token
    const apiToken = import.meta.env.VITE_MONDAY_API_TOKEN;
    const fixedBoardId = import.meta.env.VITE_BOARD_ID;
    
    if (!apiToken) {
      setApiError("Monday.com API token not configured. Please set VITE_MONDAY_API_TOKEN environment variable.");
      setApiLoading(false);
      return;
    }

    if (!fixedBoardId) {
      setApiError("Board ID not configured. Please set VITE_BOARD_ID environment variable.");
      setApiLoading(false);
      return;
    }

    mondayApi.setToken(apiToken);
    setBoardId(fixedBoardId);
    
    // Verify API token is valid
    verifyApiAccess(apiToken);
  }, []);

  const verifyApiAccess = async (token) => {
    try {
      await mondayApi.getCurrentUser();
      setApiLoading(false);
    } catch (error) {
      console.error('API verification failed:', error);
      setApiError(`Failed to connect to Monday.com API: ${error.message}`);
      setApiLoading(false);
    }
  };



  if (apiLoading) {
    return (
      <div className="App" style={{ padding: 24, textAlign: 'center' }}>
        <div>Connecting to Monday.com...</div>
      </div>
    );
  }

  if (apiError) {
    return (
      <div className="App" style={{ padding: 24, textAlign: 'center' }}>
        <div style={{ color: '#d83a52', marginBottom: '20px' }}>
          <h3>Configuration Error</h3>
          <p>{apiError}</p>
        </div>
        <div style={{ fontSize: '14px', color: '#666' }}>
          <p><strong>To fix this:</strong></p>
          <ol style={{ textAlign: 'left', display: 'inline-block' }}>
            <li>Get your Monday.com API token from Admin → Developers</li>
            <li>Set the VITE_MONDAY_API_TOKEN environment variable</li>
            <li>Set the VITE_BOARD_ID environment variable with your board ID</li>
            <li>Redeploy or restart the application</li>
          </ol>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <MondayProvider>
        <div className="App">
          <Routes>
            <Route 
              path="/" 
              element={
                boardId ? (
                  <PropertyDailyTodoList 
                    context={{ boardId: boardId }} 
                  />
                ) : (
                  <div style={{ padding: 24, textAlign: 'center' }}>
                    Loading board configuration...
                  </div>
                )
              } 
            />
          </Routes>
        </div>
      </MondayProvider>
    </Router>
  );
};

export default App;